import React from 'react';
import CompletedStepIcon from '../icons/CompletedStepIcon';
import PendingStepIcon from '../icons/PendingStepIcon';

const CheckinStep = ({ text, status = 'pending' }) => { // status can be 'completed' or 'pending'
    const Icon = status === 'completed' ? CompletedStepIcon : PendingStepIcon;

    return (
        <div className="list-group-item d-flex align-items-center border-0 p-4">
            <Icon className="me-3 flex-shrink-0" /> {/* Added flex-shrink-0 to prevent icon squishing */}
            <span>{text}</span>
        </div>
    );
};

export default CheckinStep;